import { NetworkStatus, useQuery } from '@apollo/client'
import { useState } from 'react'

import {
  PickupUsersByEvent,
  PickupUsersByEventQuery,
  PickupUsersByEventQueryVariables,
  UserPickupTicketStatus,
} from '@/clients/utoniq-core/schema'
import { useRouter } from '@/core'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from '../MyOwnedTickets/template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { router } = useRouter<{ eventId: string }>()
  const eventId = router.query.eventId
  const [type, setType] = useState<UserPickupTicketStatus>(
    UserPickupTicketStatus.All
  )
  const { data, fetchMore, refetch, networkStatus } = useQuery<
    PickupUsersByEventQuery,
    PickupUsersByEventQueryVariables
  >(PickupUsersByEvent, {
    variables: {
      eventId,
      options: {
        type,
        isHistory: true,
      },
    },
    notifyOnNetworkStatusChange: true,
  })

  return {
    state: {
      loading:
        networkStatus === NetworkStatus.loading ||
        networkStatus === NetworkStatus.setVariables,
      refetching: networkStatus === NetworkStatus.fetchMore,
      isHistory: true,
      event: data?.pickupUsersByEvent.edges[0]?.node?.event ?? null,
      hasNextPage: !!data?.pickupUsersByEvent.pageInfo.hasNextPage,
      pickupUsers: data?.pickupUsersByEvent,
      type,
    },
    actions: {
      async onFilter(inputType: UserPickupTicketStatus) {
        if (type === inputType) return

        setType(inputType)
        await refetch({
          options: {
            type: inputType,
            isHistory: true,
          },
        })
      },
      async onFetchMore() {
        await fetchMore({
          variables: {
            type,
            isHistory: true,
            pageInput: {
              cursor: data?.pickupUsersByEvent.pageInfo.endCursor,
            },
          },
        })
      },
    },
  }
})
